(function() { window.GUID_5317f2b5_49ff_4d28_b8eb_31c4ceeb8f57 = { getGuid: function() { return "5317f2b5-49ff-4d28-b8eb-31c4ceeb8f57"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatCompareSection;
        (function (StatCompareSection) {
            StatCompareSection[StatCompareSection["CSR"] = 0] = "CSR";
            StatCompareSection[StatCompareSection["ResultsAgainstEachOther"] = 1] = "ResultsAgainstEachOther";
            StatCompareSection[StatCompareSection["GameHistoryAgainstEachOther"] = 2] = "GameHistoryAgainstEachOther";
            StatCompareSection[StatCompareSection["WinRateAgainstSameOpponents"] = 3] = "WinRateAgainstSameOpponents";
            StatCompareSection[StatCompareSection["OverallResults"] = 4] = "OverallResults";
            StatCompareSection[StatCompareSection["ResultsInAnEvent"] = 5] = "ResultsInAnEvent";
            StatCompareSection[StatCompareSection["RacingBarChart"] = 6] = "RacingBarChart";
        })(StatCompareSection = Enumeration.StatCompareSection || (Enumeration.StatCompareSection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatCompareSection.pre.js.map
